/* eslint-disable */
// AUTO-GENERATED by scripts/codegen/generate.mjs from wix.isa.calendar_token.v1 — do not edit.

import { resolveUrl, toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
const _getCalendarTokenRequest = {};
const _calendarToken = {
  createdDate: 'google.protobuf.Timestamp',
  updatedDate: 'google.protobuf.Timestamp'
};
const _getCalendarTokenResponse = {
  calendarToken: '_calendarToken'
};
const _createCalendarTokenRequest = {
  calendarToken: '_calendarToken'
};
const _createCalendarTokenResponse = {
  calendarToken: '_calendarToken'
};
const _updateCalendarTokenRequest = {
  calendarToken: '_calendarToken',
  fieldMask: 'google.protobuf.FieldMask'
};
const _updateCalendarTokenResponse = {
  calendarToken: '_calendarToken'
};
const _deleteCalendarTokenRequest = {};
const _deleteCalendarTokenResponse = {};
const _queryCalendarTokensRequest = {};
const _queryCalendarTokensResponse = {
  calendarTokens: '_calendarToken'
};
const _descriptors = {
  _getCalendarTokenRequest,
  _calendarToken,
  _getCalendarTokenResponse,
  _createCalendarTokenRequest,
  _createCalendarTokenResponse,
  _updateCalendarTokenRequest,
  _updateCalendarTokenResponse,
  _deleteCalendarTokenRequest,
  _deleteCalendarTokenResponse,
  _queryCalendarTokensRequest,
  _queryCalendarTokensResponse
};
function resolveCalendarTokenServiceUrl(opts) {
  const domainToMappings = {
    'manage.nownia.com': [{
      srcPath: '/_api/calendar-token',
      destPath: ''
    }],
    'manage.orion.new': [{
      srcPath: '/_api/calendar-token',
      destPath: ''
    }],
    'manage._base_domain_': [{
      srcPath: '/_api/calendar-token',
      destPath: ''
    }],
    'www.wixapis.com': [{
      srcPath: '/individual-scheduling-assistant/v1/calendar-token',
      destPath: ''
    }]
  };
  return resolveUrl(Object.assign(opts, {
    domainToMappings
  }));
}

/** GetCalendarToken. */
export function getCalendarToken(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getCalendarTokenRequest, _descriptors);
  const fromRes = serializer(_getCalendarTokenResponse, _descriptors).fromJSON;
  function __getCalendarToken(_ref) {
    let {
      host
    } = _ref;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.calendar_token',
      method: 'GET',
      methodFqn: 'wix.isa.calendar_token.v1.CalendarTokenService.GetCalendarToken',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveCalendarTokenServiceUrl({
        protoPath: '/v1/calendar-tokens/{calendar_token_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __getCalendarToken.fromReq = fromReq;
  __getCalendarToken.__isAmbassador = true;
  return __getCalendarToken;
}

/** CreateCalendarToken. */
export function createCalendarToken(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_createCalendarTokenRequest, _descriptors);
  const fromRes = serializer(_createCalendarTokenResponse, _descriptors).fromJSON;
  function __createCalendarToken(_ref2) {
    let {
      host
    } = _ref2;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.calendar_token',
      method: 'POST',
      methodFqn: 'wix.isa.calendar_token.v1.CalendarTokenService.CreateCalendarToken',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveCalendarTokenServiceUrl({
        protoPath: '/v1/calendar-tokens',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __createCalendarToken.fromReq = fromReq;
  __createCalendarToken.__isAmbassador = true;
  return __createCalendarToken;
}

/** UpdateCalendarToken. */
export function updateCalendarToken(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_updateCalendarTokenRequest, _descriptors);
  const fromRes = serializer(_updateCalendarTokenResponse, _descriptors).fromJSON;
  function __updateCalendarToken(_ref3) {
    let {
      host
    } = _ref3;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.calendar_token',
      method: 'PATCH',
      methodFqn: 'wix.isa.calendar_token.v1.CalendarTokenService.UpdateCalendarToken',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveCalendarTokenServiceUrl({
        protoPath: '/v1/calendar-tokens/{calendar_token.id}',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __updateCalendarToken.fromReq = fromReq;
  __updateCalendarToken.__isAmbassador = true;
  return __updateCalendarToken;
}

/** DeleteCalendarToken. */
export function deleteCalendarToken(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_deleteCalendarTokenRequest, _descriptors);
  const fromRes = serializer(_deleteCalendarTokenResponse, _descriptors).fromJSON;
  function __deleteCalendarToken(_ref4) {
    let {
      host
    } = _ref4;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.calendar_token',
      method: 'DELETE',
      methodFqn: 'wix.isa.calendar_token.v1.CalendarTokenService.DeleteCalendarToken',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveCalendarTokenServiceUrl({
        protoPath: '/v1/calendar-tokens/{calendar_token_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __deleteCalendarToken.fromReq = fromReq;
  __deleteCalendarToken.__isAmbassador = true;
  return __deleteCalendarToken;
}

/** QueryCalendarTokens. */
export function queryCalendarTokens(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_queryCalendarTokensRequest, _descriptors);
  const fromRes = serializer(_queryCalendarTokensResponse, _descriptors).fromJSON;
  function __queryCalendarTokens(_ref5) {
    let {
      host
    } = _ref5;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.calendar_token',
      method: 'POST',
      methodFqn: 'wix.isa.calendar_token.v1.CalendarTokenService.QueryCalendarTokens',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveCalendarTokenServiceUrl({
        protoPath: '/v1/calendar-tokens/query',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __queryCalendarTokens.fromReq = fromReq;
  __queryCalendarTokens.__isAmbassador = true;
  return __queryCalendarTokens;
}
//# sourceMappingURL=calendarTokenHttpRequests.js.map